import { defineComponent as _defineComponent } from 'vue'
import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import type { Post } from '@@/types'
import { computed } from 'vue'

import { useSurfaceAttachmentsStore } from '@@/pinia/surface_attachments'
import type { BeethovenDisplayAttributes } from '@padlet/beethoven-client'


export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteboardAttachmentCornerActionButton',
  props: {
    post: null,
    displayAttributes: null,
    interaction: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (name: 'click', event: MouseEvent): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  post: Post
  displayAttributes: BeethovenDisplayAttributes
  interaction: 'link' | 'padlet' | 'expand' | 'play' | 'download'
};

const surfaceAttachmentsStore = useSurfaceAttachmentsStore()



const iconName = computed(() => {
  switch (props.interaction) {
    case 'link':
      return 'external_link'
    case 'padlet':
      return 'external_link'
    case 'expand':
      return 'expand_post'
    case 'play':
      return 'play_outline'
    case 'download':
      return 'download_outline'
  }
  return 'external_link'
})

const xCornerButton = computed(() => {
  if (props.displayAttributes?.content_category === 'photo') return false
  if (props.displayAttributes?.content_category === 'video') return false
  if (props.displayAttributes?.content_category === 'audio') return false
  return true
})

return { __sfc: true,surfaceAttachmentsStore, emit, props, iconName, xCornerButton, OzBaseButton, OzIcon }
}

})